<div class="button-demo">
  <div class="button-demo-row">
    <mad-primary-button title="Save" type="button" (click)="onClick()">Save</mad-primary-button>
    <mad-outline-button title="Cancel" type="button" (click)="onClick()">Cancel</mad-outline-button>
    <mad-outline-button title="Assign" type="button" color="accent" (click)="onClick()">Assign</mad-outline-button>
    <mad-outline-button title="Archive" type="button" color="warn" (click)="onClick()">Archive</mad-outline-button>
    <mad-danger-button title="Delete forever" type="button" (click)="onClick()">Delete forever</mad-danger-button>
    <mad-link-button title="Add item" type="button" (click)="onClick()">Add item</mad-link-button>
    <mad-icon-button title="Create" type="button" (click)="onClick()">
      <mat-icon>create</mat-icon>
    </mad-icon-button>
  </div>

  <div class="button-demo-row">
    <mad-primary-button title="Disabled primary" type="button" [disabled]="true" (click)="onClick()">Disabled primary</mad-primary-button>
    <mad-outline-button title="Disabled outline" type="button" [disabled]="true" (click)="onClick()">Disabled outline</mad-outline-button>
    <mad-danger-button title="Disabled danger" type="button" [disabled]="true" (click)="onClick()">Disabled danger</mad-danger-button>
    <mad-icon-button title="Create" type="button" [disabled]="true" (click)="onClick()">
      <mat-icon>create</mat-icon>
    </mad-icon-button>
  </div>
</div>
